// @flow

import React, { useState } from "react";
import classNames from "classnames";

import Checkbox from "@components/checkbox";
import type { WidgetProps } from "@rjsf/utils";

type Props = $Exact<{
  ...WidgetProps,
  options: Object,
}>;

export function CheckboxWidget(params: Props) {
  const [checked, setChecked]: [boolean | string, Function] = useState(params.value);

  function handleChange(state) {
    const checked = params.schema.type === "boolean" ? state === "true" : state;
    setChecked({ state: checked });
    return params.onChange(checked);
  }

  const props = Object.assign({}, params, {
    readOnly: params.readonly,
    autoFocus: params.autofocus,
    onChange: handleChange,
    checked: checked,
  });

  return (
    <Checkbox
      id={`${props.id}_el`}
      label={props.options.labelposition !== "left" ? props.label : ""}
      checked={params.value}
      disabled={params.disabled}
      readOnly={params.readonly}
      onChange={handleChange}
      className={`schema-form-widget-checkbox form-control ${props.className}`}
    />
  );
}

export default CheckboxWidget;
